import { createContext, useContext, useState, useEffect } from 'react';
import { login as apiLogin, register as apiRegister, getMe } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('mds_token');
    if (token) {
      getMe()
        .then((res) => setUser(res.data.user))
        .catch(() => { localStorage.removeItem('mds_token'); localStorage.removeItem('mds_user'); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await apiLogin({ email, password });
    localStorage.setItem('mds_token', res.data.token);
    localStorage.setItem('mds_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data.user;
  };

  const register = async (data) => {
    // Registration only creates the account and sends a verification email.
    // The server does NOT return a token or user object at this stage —
    // the user must verify their email before they can log in.
    const res = await apiRegister(data);
    return res.data; // { success, message, email_verification_required }
  };

  const logout = () => {
    localStorage.removeItem('mds_token');
    localStorage.removeItem('mds_user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
